export const TOAST_MESSAGE = 'TOAST_MESSAGE';
export const INPUT_ERROR_TEXT = 'INPUT_ERROR_TEXT';
